export const COMPANY_FOLLOWER_QUERY_KEY = "companies::company::follower"
